// extracted by mini-css-extract-plugin
module.exports = {"di89ht1":"di89ht1"};